// assets
import Acupuncture from 'assets/icons/homePage/Acupuncture.svg';
import BirthEducation from 'assets/icons/homePage/BirthEducation.svg';
import Chiropractic from 'assets/icons/homePage/Chiropractic.svg';
import Doula from 'assets/icons/homePage/Doula.svg';
import Exercise from 'assets/icons/homePage/Exercise.svg';
import FertilityCoaching from 'assets/icons/homePage/FertilityCoaching.svg';
import Coaching from 'assets/icons/homePage/Coaching.svg';
import InfantSleep from 'assets/icons/homePage/InfantSleep.svg';
import Lactation from 'assets/icons/homePage/Lactation.svg';
import MassageTherapy from 'assets/icons/homePage/MassageTherapy.svg';
import MentalHealth from 'assets/icons/homePage/MentalHealth.svg';
import Nutrition from 'assets/icons/homePage/Nutrition.svg';
import PhysicalTherapy from 'assets/icons/homePage/PhysicalTherapy.svg';
import OccupationalTherapy from 'assets/icons/homePage/OccupationalTherapy.svg';

const HOME_PAGE_CONTENT = {
  mainSectionTitle: 'Find & Book Parental Wellness Specialists',
  mainSectionSubtitle:
    "Everyone has a unique path to parenthood. From fertility through early parenthood, we're here to help aspiring, expecting and new parents find support.",
  connectSectionTitle: "We're here to connect you with specialists for your unique journey",
  connectSectionSubtitle:
    'Robyn providers collaborate with reproductive endocrinologists, OB-GYNS, and other physicians on treatment plans that complement your primary care.',
  servicesSectionTitle: 'Find the service that’s right for you.',
  servicesSectionSubtitle:
    'Roll over to learn more about each wellness category and why it’s important during fertility through early childhood.',
};

export const SERVICE_ICONS = {
  Acupuncture: Acupuncture,
  'Birth Education': BirthEducation,
  Chiropractic: Chiropractic,
  Doula: Doula,
  Exercise: Exercise,
  'Infant Sleep': InfantSleep,
  Lactation: Lactation,
  'Massage Therapy': MassageTherapy,
  'Mental Health': MentalHealth,
  Nutrition: Nutrition,
  Coaching: Coaching,
  'Fertility Coaching': FertilityCoaching,
  'Physical Therapy': PhysicalTherapy,
  'Occupational Therapy': OccupationalTherapy,
};

export const SERVICE_DESCRIPTIONS = {
  Acupuncture:
    'A preventative and therapeutic treatment commonly used for reproductive health that can impact blood flow, hormones and more.',
  'Birth Education': 'Feel empowered and armed with knowledge as you enter into your birth with a childbirth educator.',
  Chiropractic: 'Reduce stress and interference in the body with chiropractic treatments.',
  Doula:
    'Birth, Postpartum and Loss Doulas can help to empower and strengthen you through any time of big life transition.',
  Exercise:
    'Fertility yoga, pregnancy movement specialists and postpartum diastasis instructors can help you to feel at home in your body.',
  'Infant Sleep':
    'Get support to help your infant sleep better. All different kinds of methods and philosophies available.',
  Lactation: 'Get breastfeeding, bottle feeding or formula feeding  support from a certified lactation consultant.',
  'Massage Therapy':
    'Fertility, pregnancy and post partum massage therapists specialize in serving your body and what it needs at each stage.',
  'Mental Health':
    'Suffering can be alleviated with the support of a mental health professional specializing in aspiring, expecting and new parents.',
  Nutrition:
    'Registered Dietitians and Nutritionists help you to control what you can control during these times of transition, your diet.',
  Coaching:
    'Whether it’s an ongoing accountability partner or someone to help you “take out the mental trash” find the right coach for you.',
  'Fertility Coaching':
    'Fertility treatments can be confusing and overwhelming. Get a nurturing, knowledgeable partner to help you navigate the journey.',
  'Physical Therapy':
    'As aspiring, expecting and new parents, our bodies are going through a lot. Specialists focus on the shared challenges we experience, like pelvic floor therapy.',
  'Occupational Therapy':
    'An occupational therapist can make your daily life easier by addressing existing or newly developed problems, limitations and disabilities.',
};

export default HOME_PAGE_CONTENT;
